import {
  IAuthAccess,
  IUserSession,
} from 'modules/authentication/domain/entities';
import { IJwtProvider } from 'modules/authentication/domain/providers';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import IStorageProvider from 'shared/domain/providers/IStorageProvider';

export default class SyncUserSessionUseCase {
  constructor(
    private storageProvider: IStorageProvider,
    private httpProvider: IHTTPProvider,
    private jwtProvider: IJwtProvider,
  ) {}

  public async execute() {
    const authentication = this.storageProvider.get('AUTHENTICATION');

    if (!authentication || !this.isAuthenticationValid(authentication)) {
      this.httpProvider.setHeader('AUTHENTICATION', null);
      this.storageProvider.delete('AUTHENTICATION');

      return null;
    }

    this.httpProvider.setHeader(
      'AUTHENTICATION',
      `Bearer ${authentication.auth.accessToken}`,
    );

    return authentication.session;
  }

  private isAuthenticationValid(authentication: {
    auth: IAuthAccess;
    session: IUserSession;
  }) {
    const token = authentication.auth.accessToken;
    const id = authentication.session.id;

    const decoded = this.jwtProvider.decode<{ uid: number }>(token);

    return decoded.uid === id;
  }
}
